var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var processDATA = require("./process-data.js");
var $ = require('./lib/qsa');

console.clear();
var processed = processDATA(window.territories, window.countries, window.populations);
window.processed = processed;

// DATA
// geo data
var geo_data = [];
var geo_data_pre;
var mainProperty = "confirmed";
var mainPropertyOverride = "confirmed_override";
var deathProperty = "deaths";
var deathPropertyOverride = "deaths_override";
var nameProperty = "name_display";

var centered;
var path;
var chartElement;
var chartWrapper;
var maxTooltipWidth = 200;
var chartWidth;
var chartHeight;

var pymChild;

var {fmtComma, classify } = require("./lib/helpers");
var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-geo/dist/d3-geo.min"),
  ...require("d3-geo-projection/dist/d3-geo-projection.min"),
  // ...require("d3-transition/dist/d3-transition.min")
};

//Initialize graphic
var onWindowLoaded = async function() {

  var response = await fetch("./assets/worked/countries_filtered.json");
  geo_data_pre = await response.json();

  formatData();
  render();

  window.addEventListener("resize", render);
  $.one('.controls').addEventListener('change', render);

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

// formatData
var formatData = function() {
  // join DATA to geo_data
  for(let i=0; i<geo_data_pre.features.length; i++) {
    geo_data.push({
     ...geo_data_pre.features[i],
     ...(processed.find((itmInner) => itmInner.name_geo === geo_data_pre.features[i].properties.NAME))}
    );
  }
}

var isPlural = function(d) {
  if (d == 1) {
    return "";
  } else {
    return "s";
  }
}

var labelSide = function(d) {
  if (d == "right") {
    return 1;
  } else {
    return -1;
  }
}

var render = async function() {
  var container = "#map-container";
  var element = document.querySelector(container);
  var width = element.offsetWidth;

  var selected = $.one(`input[type=radio]:checked`);

  renderMap({
    container,
    width,
    data: geo_data,
    sublabel: selected.dataset.sublabel,
  }, selected.value,
  selected.value == "cases_per_capita" ? "deaths_per_capita" : "deaths");

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }

};

var renderMap = function(config, mainProperty, deathProperty) {
  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 9;

  var margins = {
    top: 30,
    right: 0,
    bottom: 10,
    left: 0
  };

  var radiusMax = 20;
  var radiusMin = 1;

  // Mobile params
  if (isMobile.matches) {
    radiusMax = 12;
  }

  // Calculate actual chart dimensions
  chartWidth = config.width - margins.left - margins.right;
  chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create Robinson projection of world.
  // Move center down to compensate for Antarctica removed.
  var projection = d3.geoRobinson()
    .translate([chartWidth / 2, chartHeight / 2]) // translate to center of screen
    .scale(config.width / 1.85 / Math.PI)
    .center([15, 20]);

  path = d3.geoPath()
    .projection(projection);

  // Get max and min of mainProperty for circle creation.
  var values = config.data
    .map(d => d[mainProperty] || 0);
  var max = Math.max(...values);

  var radius = d3.scaleSqrt()
      .domain([0, max])
      .range([radiusMin, radiusMax]);

  // Create the root SVG element.
  chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .attr("role", "img") // screenreader support
    .attr("aria-labelledby", "map-circles-" + classify(mainProperty)) // screenreader support
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

    // screenreader support
    var generateDescription = function(toggle) {
      var unit;

      switch (toggle) {
        case "cases_weeks":
          unit = "new cases in the past week";
          break;
        case "cases_per_capita_weeks":
          unit = "new cases in the past week per 100,000 people";
          break;
        case "confirmed":
          unit = "total coronavirus cases";
          break;
        case "cases_per_capita":
          unit = "total coronavirus cases per 100,000 people";
          break;
        default:
          unit = " ";
          break;
      }

      var descData = config.data.sort((a, b) => b[mainProperty] - a[mainProperty]).slice(0,3);
      // console.log(config.data, descData)

      return "Map of the world showing " + unit + " in each country. " + descData[0].name_display + ", " + descData[1].name_display + " and " + descData[2].name_display + " have the most " + unit + ". Use the table below to see total cases and deaths for each country, ordered by countries with the highest total cases.";
    }

    chartElement.append("desc")
      .text(generateDescription(mainProperty))
      .attr("id", "map-circles-" + classify(mainProperty));

  // Render Map
  chartElement.selectAll(".countries")
      .data(config.data.sort(function(a, b) {
        var aProp = a[mainProperty] ? a[mainProperty] : 0;
        var bProp = b[mainProperty] ? b[mainProperty] : 0;
        return aProp - bProp;
      }))
      .enter().append("path")
      .attr("class", d => !isNaN(d[mainProperty]) ? "country on" : "country")
      .attr("d", path);

  d3.select('.label-sub').text(config.sublabel);

  // add in tooltip for individual country display.
  var tooltip = d3.select("#map-container")
    .append("div")
    .attr("id", "country-tooltip")
    .style("position", "absolute")
    .style("z-index", "10")
    .style("visibility", "hidden")
    .style("background", "#fff")
    .text("");
  var mainTooltipLabel = tooltip.append("div")
    .attr("class", "label main");
  var secondaryTooltipLabel = tooltip.append("div")
    .attr("class", "label secondary cases");
  var optionalSecondaryTooltipLabel = tooltip.append("div")
    .attr("class", "label secondary cases");
  var deathsTooltipLabel = tooltip.append("div")
    .attr("class", "label secondary deaths");

  // Render infection bubbles and set up mouseover tooltip.
  chartElement.selectAll("circle.bubble")
    .data(config.data.sort(function(a,b) {
      var aProp = a[mainProperty] ? a[mainProperty] : 0;
      var bProp = b[mainProperty] ? b[mainProperty] : 0;
      return bProp - aProp;
    }))
    .enter()
    .append("circle")
    .attr("class","bubble")
    .attr("r",function(d){
      if (d[mainProperty] && d[mainProperty] > 0) {
        return radius(d[mainProperty]);
      }
      // Add me back in to display a circle even for unaffected countries.
      else if (d[mainProperty] == 0) {
        return radius(1);
      }
    })
    .attr("transform", function(d) {
      return `translate(${getCenter(d, projection)})`;
    })
    .on("mouseover", function(d){
      // Don't do tooltips on mobile.
      if (isMobile.matches) {
        return;
      }
      var radius = parseInt(this.getAttribute("r"));

      mainTooltipLabel.text(d[nameProperty]);
      secondaryTooltipLabel.text(getLabelText(d, "case", mainProperty, mainPropertyOverride));
      if (!mainProperty.match(/weeks/)) {
        deathsTooltipLabel.text(getLabelText(d, "death", deathProperty, deathPropertyOverride));
      } else {
        var property = mainProperty.match(/capita/) ? "cases_per_capita" : "confirmed";
        optionalSecondaryTooltipLabel.text(getLabelText(d, "total case", property, mainPropertyOverride))
      }

      // set tooltip positions. If tooltip too far to the right, move
      // to righthand side of country.
      var element = d3.select('#country-tooltip').node();
      var tooltipWidth = element.getBoundingClientRect().width;
      var center = getCenter(d, projection);
      tooltip.style("top", center[1] + "px");
      var offset = center[0] + 5 + radius;
      if (offset >= chartWidth - maxTooltipWidth) {
        offset = center[0] - 5 - radius - tooltipWidth;
      }
      tooltip.style("left", offset + "px");

      return tooltip.style("visibility", "visible");
    })
    .on("mouseout", function(){return tooltip.style("visibility", "hidden")});

  var textGroups = chartElement.selectAll("g.labelGroup")
    .data(config.data.filter(d => d.label == true))
    .enter()
    .append("g")
    .attr("class","labelGroup")
    .attr("transform", function(d) {
      return `translate(${getCenter(d, projection)})`
    })

  textGroups
    .append("text")
    .attr("class","label main")
    .attr("dy", 5)
    .attr("dx", d => (radius(d[mainProperty]) + d.label_offsetX)*labelSide(d.labelSide))
    .attr("text-anchor", d => d.labelSide == "right" ? "start" : "end")
    .text(d => d[nameProperty]);

  textGroups
    .append("text")
    .attr("class","label secondary cases")
    .attr("dy", 20)
    .attr("dx", d => (radius(d[mainProperty]) + d.label_offsetX)*labelSide(d.labelSide))
    .attr("text-anchor", d => d.labelSide == "right" ? "start" : "end")
    .text(function(d){
      return getLabelText(d, "case", mainProperty, mainPropertyOverride);
    });

  textGroups
    .append("text")
    .attr("class","label secondary deaths")
    .attr("dy", 35)
    .attr("dx", d => (radius(d[mainProperty]) + d.label_offsetX)*labelSide(d.labelSide))
    .attr("text-anchor", d => d.labelSide == "right" ? "start" : "end")
    .text(function(d){
        return getLabelText(d, "death", deathProperty, deathPropertyOverride);
    })

  textGroups
    .append("line")
    .attr("class","annoLine")
    .attr("x1",d => (radius(d[mainProperty]) + d.label_offsetX - 3 )*labelSide(d.labelSide))
    .attr("x2",d => (radius(d[mainProperty]) + 3)*labelSide(d.labelSide))
    .attr("y1",0)
    .attr("y2",0);

};

function getLabelText(data, label, prop, overrideProp) {
  var number = data[overrideProp] > data[prop] ? data[overrideProp] : data[prop];
  var perCap = prop.includes("per") ? " per 100k" : ""
  var lastXWeeks = prop.includes("weeks") ? " in last week" : ""

  return `${fmtComma(number)} ${label}${isPlural(number)} ${perCap} ${lastXWeeks}`
}

// Gets the center for an geography.
function getCenter(d, projection) {
  var center = projection(d3.geoCentroid(d));

  // Necessary special cases for US and Canada
  if (d[nameProperty] == "United States") {
    center[1] = center[1] + chartHeight * .03;
  }
  if (d[nameProperty] == "Canada") {
    center[0] = center[0] - chartWidth * .03;
  }
  if (d[nameProperty] == "France") {
    center[0] = center[0] + chartWidth * .02;
    center[1] = center[1] - chartWidth * .01;
  }

  return center;
}

// Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
